import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const savedToken = localStorage.getItem('ets_token');
      const savedAdmin = localStorage.getItem('ets_admin');
      if (savedToken && savedAdmin) {
        setToken(savedToken);
        setAdmin(JSON.parse(savedAdmin));
      }
    } catch (e) {
      localStorage.removeItem('ets_token');
      localStorage.removeItem('ets_admin');
    } finally {
      setLoading(false);
    }
  }, []);

  const login = (newToken, newAdmin) => {
    setToken(newToken);
    setAdmin(newAdmin);
    localStorage.setItem('ets_token', newToken);
    localStorage.setItem('ets_admin', JSON.stringify(newAdmin));
  };

  const logout = () => {
    setToken(null);
    setAdmin(null);
    localStorage.removeItem('ets_token');
    localStorage.removeItem('ets_admin');
  };

  return (
    <AuthContext.Provider value={{ token, admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
